import { render, staticRenderFns } from "./ModalCreateOrganizationManualContent.vue?vue&type=template&id=b4ee4ce4&scoped=true"
import script from "./ModalCreateOrganizationManualContent.vue?vue&type=script&lang=js"
export * from "./ModalCreateOrganizationManualContent.vue?vue&type=script&lang=js"
import style0 from "../../../node_modules/vue-tel-input/dist/vue-tel-input.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ee4ce4",
  null
  
)

export default component.exports